module.exports = __webpack_public_path__ + "media/blink.44bafe09.mp3";